<rid-demo-page [title]="'Expressie'" previousRoute="/mechanics">
  <rid-button class="w-full" content="Dialoog" variant="PRIMARY" routerLink="dialog" />
  <rid-button class="w-full" content="Expressief lezen" variant="PRIMARY" routerLink="expressive-reading" />
</rid-demo-page>
